(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[55655,65250],{

/***/ 55655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DebtReliefCornerWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/debtreliefcorner/logo/index.tsx


function DebtReliefCornerLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "370",
        height: "40",
        fill: "none",
        viewBox: "0 0 370 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1_65)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7478B9",
                        d: "M48.585 7.61h-32.39V40h32.39V7.61z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "url(#paint0_linear_1_65)",
                        d: "M44.537 11.658H16.195v24.293h28.342V11.658z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7478B9",
                        d: "M44.537 15.707v-4.049h-4.05a4.048 4.048 0 004.05 4.05zM40.488 35.951h4.049v-4.049a4.048 4.048 0 00-4.05 4.05z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        stroke: "#fff",
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "0.8",
                        d: "M44.537 15.707a4.048 4.048 0 01-4.05-4.049H16.196M16.195 35.951h24.293a4.048 4.048 0 014.049-4.049V15.707"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#253F91",
                        d: "M32.39 3.56L16.195 19.757v20.06l16.195-3.865V3.561z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7478B9",
                        d: "M32.39 3.56H0v32.391h32.39V3.561z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#9293C9",
                        d: "M32.39 7.61H4.05v24.292H32.39V7.61z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M18.837 17.012c2.104 1.331 3.454 2.338 4.03 3.017.773.918 1.166 1.995 1.166 3.237 0 1.356-.456 2.503-1.375 3.447-.919.938-2.192 1.476-3.82 1.622v1.546h-1.154v-1.457c-.938-.02-1.761-.095-2.484-.235-.722-.139-1.552-.386-2.483-.747v-4.27h.557c.178.969.457 1.754.83 2.35.38.602.856 1.052 1.432 1.356.577.304 1.293.494 2.148.564v-6.533c-2.122-1.33-3.535-2.395-4.239-3.193a4.072 4.072 0 01-1.051-2.782c0-1.147.443-2.154 1.324-3.035.88-.874 2.205-1.425 3.966-1.647V9.63h1.153v.62c1.496.109 3.004.571 4.524 1.388v3.821h-.513c-.253-.862-.564-1.571-.919-2.129a5.01 5.01 0 00-1.38-1.425c-.432-.292-1.002-.533-1.705-.73v5.83l-.007.006zm-1.153-5.873c-.646.05-1.16.228-1.546.526-.614.469-.925 1.033-.925 1.692 0 .405.146.817.431 1.229.285.412.97.976 2.04 1.691v-5.145.007zm1.153 16.303c.76-.178 1.312-.476 1.667-.906.355-.425.526-.963.526-1.61 0-.557-.159-1.077-.47-1.558-.31-.482-.886-1.033-1.723-1.654v5.728z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#7478B9",
                        d: "M4.049 27.854v4.048h4.049a4.048 4.048 0 00-4.05-4.049zM8.098 7.61h-4.05v4.048a4.048 4.048 0 004.05-4.048z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        stroke: "#fff",
                        strokeLinecap: "square",
                        strokeMiterlimit: "10",
                        strokeWidth: "0.8",
                        d: "M4.049 27.854a4.048 4.048 0 014.049 4.048H32.39M32.39 7.61H8.098a4.048 4.048 0 01-4.05 4.048v16.196"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M49.365 30.363c7.824 0 14.167-6.343 14.167-14.168 0-7.824-6.343-14.167-14.167-14.167-7.825 0-14.168 6.343-14.168 14.167 0 7.825 6.343 14.168 14.168 14.168z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#253F91",
                        d: "M58.668 5.457l-2.146 2.146 1.43 1.43 2.145-2.147-1.429-1.429zM50.372 2.021h-2.02v3.035h2.02V2.021z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F68740",
                        d: "M49.365 28.342c6.708 0 12.146-5.439 12.146-12.147S56.073 4.05 49.365 4.05c-6.708 0-12.147 5.438-12.147 12.146 0 6.708 5.439 12.147 12.147 12.147z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M49.365 25.306a9.111 9.111 0 100-18.222 9.111 9.111 0 000 18.223z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F68740",
                        d: "M49.365 8.604a7.588 7.588 0 00-7.59 7.591h7.59v-7.59z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M49.365 18.723a2.531 2.531 0 01-2.528-2.528c0-.805.386-1.546 1.013-2.015V8.098h3.035v6.082a2.518 2.518 0 011.014 2.015 2.531 2.531 0 01-2.528 2.528h-.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#253F91",
                        d: "M49.365 17.716a1.52 1.52 0 100-3.041 1.52 1.52 0 000 3.04z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#253F91",
                        d: "M49.872 8.098h-1.014v8.097h1.014V8.098z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#F68740",
                        d: "M53.414 0h-8.098v2.021h8.098V0z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#253F91",
                        d: "M73.132 38.46V13.813h8.895c2.364 0 4.525.538 6.495 1.622 1.964 1.083 3.523 2.566 4.67 4.448 1.147 1.882 1.717 3.973 1.717 6.266 0 2.294-.57 4.378-1.71 6.254-1.141 1.875-2.694 3.358-4.652 4.442-1.957 1.083-4.112 1.622-6.462 1.622h-8.947l-.006-.007zm9.105-4.511c1.463 0 2.794-.342 3.991-1.02a7.406 7.406 0 002.826-2.8c.685-1.186 1.027-2.516 1.027-3.992 0-1.477-.342-2.807-1.033-3.999a7.429 7.429 0 00-2.845-2.807c-1.204-.677-2.547-1.02-4.017-1.02H77.89v15.632h4.353l-.006.006zM102.05 30.774c.291 1.312.919 2.338 1.888 3.086.969.748 2.11 1.122 3.428 1.122 1.698 0 3.149-.564 4.372-1.686l2.141 3.105a9.543 9.543 0 01-3.028 1.875c-1.141.444-2.389.666-3.745.666-1.787 0-3.409-.431-4.853-1.293a9.23 9.23 0 01-3.397-3.497c-.817-1.477-1.229-3.08-1.229-4.829 0-1.748.387-3.383 1.16-4.86.773-1.476 1.844-2.642 3.218-3.497 1.375-.862 2.915-1.292 4.626-1.292 1.882 0 3.51.405 4.879 1.216a7.966 7.966 0 013.123 3.377c.716 1.439 1.071 3.08 1.071 4.93 0 .564-.038 1.083-.108 1.559H102.05v.018zm1.736-6.203c-.843.672-1.407 1.603-1.705 2.801h9.302c-.273-1.217-.798-2.154-1.59-2.813-.792-.66-1.787-.989-2.991-.989-1.204 0-2.173.336-3.016 1.008v-.007zM133.876 20.96a9.545 9.545 0 013.377 3.491c.837 1.47 1.255 3.08 1.255 4.834 0 1.756-.418 3.365-1.249 4.835a9.443 9.443 0 01-3.377 3.491 8.759 8.759 0 01-4.625 1.293c-1.172 0-2.23-.235-3.174-.69a7.687 7.687 0 01-2.472-1.902l-.316 2.16h-3.91V12.584h4.512v9.353c1.425-1.508 3.218-2.262 5.366-2.262 1.66 0 3.2.43 4.613 1.292v-.006zm-2.357 13.008a4.932 4.932 0 001.869-1.914c.456-.817.684-1.736.684-2.756 0-1.02-.228-1.939-.684-2.762a5.059 5.059 0 00-1.875-1.94 5.095 5.095 0 00-2.63-.703c-.957 0-1.863.235-2.667.704a5.158 5.158 0 00-1.914 1.939c-.469.823-.703 1.742-.703 2.762s.234 1.933.703 2.744a5.093 5.093 0 001.914 1.913c.804.463 1.698.69 2.667.69.97 0 1.85-.227 2.642-.683l-.006.006zM147.138 38.46h-4.493V24.18h-2.629v-4.125h2.617v-4.385l4.511-1.07v5.455h4.055v4.125h-4.055V38.46h-.006zM177.646 38.46h-5.367l-3.858-8.313c-.514.026-.906.032-1.179.032h-4.125v8.281h-4.752V13.813h10.176c1.673 0 3.149.342 4.429 1.026 1.28.684 2.275 1.641 2.984 2.877.71 1.235 1.065 2.661 1.065 4.27 0 1.61-.355 3.023-1.071 4.182-.716 1.166-1.704 2.079-2.965 2.744l4.669 9.542-.006.006zm-14.529-12.476h5c.792 0 1.501-.17 2.122-.506a3.63 3.63 0 001.438-1.413c.343-.602.507-1.293.507-2.06 0-.766-.177-1.482-.526-2.072a3.477 3.477 0 00-1.444-1.343c-.615-.31-1.305-.462-2.078-.462h-5.019v7.863-.006zM183.507 30.774c.292 1.312.919 2.338 1.888 3.086.97.748 2.11 1.122 3.428 1.122 1.698 0 3.149-.564 4.366-1.686l2.141 3.105a9.543 9.543 0 01-3.028 1.875c-1.141.444-2.389.666-3.745.666-1.787 0-3.409-.431-4.854-1.293a9.24 9.24 0 01-3.396-3.497c-.817-1.477-1.229-3.08-1.229-4.829 0-1.748.387-3.383 1.16-4.86.773-1.476 1.843-2.642 3.218-3.497 1.375-.862 2.915-1.292 4.626-1.292 1.882 0 3.51.405 4.879 1.216a7.966 7.966 0 013.123 3.377c.71 1.439 1.071 3.08 1.071 4.93a9.93 9.93 0 01-.108 1.559h-13.546l.006.018zm1.736-6.203c-.843.672-1.406 1.603-1.704 2.801h9.301c-.266-1.217-.798-2.154-1.59-2.813-.792-.66-1.787-.989-2.991-.989-1.204 0-2.173.336-3.016 1.008v-.007zM205.278 38.46h-4.454V12.178h4.454V38.46zM210.936 16.556a2.83 2.83 0 01-1.001-.988 2.527 2.527 0 010-2.604c.241-.418.57-.754 1.001-1.008a2.71 2.71 0 011.445-.386c.538 0 1.02.127 1.445.386.424.26.76.596 1.001 1.008.24.418.361.849.361 1.305 0 .456-.121.887-.361 1.299a2.685 2.685 0 01-1.001.988c-.425.254-.913.38-1.445.38s-1.02-.126-1.445-.38zm3.656 21.904h-4.473V20.054h4.473V38.46zM222.683 30.774c.292 1.312.919 2.338 1.889 3.086.963.748 2.109 1.122 3.427 1.122 1.698 0 3.149-.564 4.366-1.686l2.142 3.105a9.558 9.558 0 01-3.029 1.875c-1.141.444-2.389.666-3.745.666-1.787 0-3.409-.431-4.853-1.293a9.225 9.225 0 01-3.396-3.497c-.818-1.477-1.23-3.08-1.23-4.829 0-1.748.387-3.383 1.16-4.86.773-1.476 1.844-2.642 3.219-3.497 1.375-.862 2.914-1.292 4.625-1.292 1.882 0 3.51.405 4.879 1.216a7.969 7.969 0 013.124 3.377c.716 1.439 1.07 3.08 1.07 4.93 0 .564-.031 1.083-.107 1.559h-13.547l.006.018zm1.736-6.203c-.842.672-1.406 1.603-1.704 2.801h9.295c-.266-1.217-.798-2.154-1.59-2.813-.792-.66-1.787-.989-2.991-.989-1.204 0-2.173.336-3.016 1.008l.006-.007zM240.406 38.46V24.18h-2.421v-4.125h2.421v-2.262c0-4.188 2.319-6.28 6.963-6.28.418 0 .703 0 .843.02l.564.019v3.928a36.992 36.992 0 00-1.211-.038c-.925 0-1.603.24-2.034.722-.43.482-.646 1.198-.646 2.161v1.736h3.84v4.125h-3.827v14.282h-4.492v-.007zM259.433 37.18a12.541 12.541 0 01-4.613-4.631c-1.128-1.952-1.692-4.1-1.692-6.438s.564-4.498 1.692-6.437a12.522 12.522 0 014.613-4.607c1.945-1.128 4.093-1.691 6.45-1.691 1.59 0 3.098.266 4.518.798a12.702 12.702 0 013.814 2.236l-2.686 3.6a9.512 9.512 0 00-2.624-1.502 8.357 8.357 0 00-3.028-.57 7.552 7.552 0 00-3.948 1.09 8.05 8.05 0 00-2.902 2.965c-.722 1.254-1.077 2.63-1.077 4.137 0 1.508.361 2.89 1.077 4.144a8.002 8.002 0 002.902 2.965 7.611 7.611 0 003.948 1.09c1.064 0 2.046-.171 2.946-.52.9-.342 1.818-.886 2.756-1.621l2.63 3.63a12.866 12.866 0 01-3.827 2.262c-1.42.539-2.921.805-4.512.805-2.35 0-4.498-.564-6.45-1.705h.013zM280.716 37.68a9.608 9.608 0 01-3.51-3.49c-.862-1.47-1.293-3.08-1.293-4.835s.431-3.39 1.293-4.879a9.504 9.504 0 013.516-3.516c1.483-.862 3.124-1.293 4.911-1.293 1.786 0 3.428.431 4.91 1.3a9.604 9.604 0 013.517 3.516c.861 1.482 1.292 3.104 1.292 4.866 0 1.761-.431 3.37-1.292 4.84a9.43 9.43 0 01-3.529 3.492c-1.489.855-3.137 1.28-4.936 1.28-1.8 0-3.409-.431-4.885-1.293l.006.013zm7.578-3.63a5.184 5.184 0 001.901-1.958c.462-.83.703-1.748.703-2.756 0-1.007-.234-1.939-.703-2.775a5.228 5.228 0 00-1.914-1.964 5.072 5.072 0 00-2.648-.723 5.187 5.187 0 00-4.562 2.686c-.469.831-.704 1.756-.704 2.776 0 1.02.235 1.939.704 2.763a5.185 5.185 0 001.901 1.945c.798.475 1.685.71 2.661.71.975 0 1.856-.235 2.655-.71l.006.006zM310.198 20.06a8.578 8.578 0 012.104 1.07l-1.984 3.65c-.912-.64-1.85-.963-2.807-.963-.678.013-1.324.229-1.932.64-.608.419-1.103 1.002-1.483 1.755-.38.755-.583 1.629-.608 2.624v9.63h-4.473V20.08h3.839l.317 2.471c.513-.9 1.191-1.603 2.028-2.103.836-.5 1.786-.754 2.851-.754.703 0 1.413.12 2.142.367h.006zM328.345 20.611c1.096.628 1.939 1.534 2.534 2.718.596 1.185.894 2.605.894 4.252v10.88h-4.493V28.372c0-1.45-.355-2.572-1.058-3.37-.71-.8-1.692-1.192-2.959-1.192-.83 0-1.597.197-2.287.596-.697.399-1.248.937-1.648 1.615a4.292 4.292 0 00-.608 2.243V38.46h-4.473V20.073h3.84l.297 2.389c.678-.83 1.578-1.502 2.7-2.015 1.121-.514 2.255-.773 3.402-.773 1.476 0 2.756.31 3.852.937h.007zM339.268 30.774c.292 1.312.919 2.338 1.888 3.086.963.748 2.11 1.122 3.428 1.122 1.698 0 3.149-.564 4.366-1.686l2.141 3.105a9.543 9.543 0 01-3.028 1.875c-1.141.444-2.389.666-3.745.666-1.787 0-3.409-.431-4.854-1.293a9.24 9.24 0 01-3.396-3.497c-.817-1.47-1.229-3.08-1.229-4.829 0-1.748.387-3.383 1.16-4.86.773-1.476 1.843-2.642 3.218-3.497 1.375-.862 2.915-1.292 4.626-1.292 1.882 0 3.51.405 4.879 1.216a7.966 7.966 0 013.123 3.377c.716 1.439 1.071 3.08 1.071 4.93 0 .564-.038 1.083-.108 1.559h-13.546l.006.018zm1.736-6.203c-.843.672-1.406 1.603-1.704 2.801h9.301c-.266-1.217-.798-2.154-1.59-2.813-.792-.66-1.787-.989-2.991-.989-1.204 0-2.173.336-3.016 1.008v-.007zM367.762 20.06a8.572 8.572 0 012.103 1.07l-1.983 3.65c-.912-.64-1.85-.963-2.807-.963-.678.013-1.324.229-1.932.64-.608.419-1.103 1.002-1.483 1.755-.38.755-.583 1.629-.608 2.624v9.63h-4.473V20.08h3.839l.317 2.471c.513-.9 1.191-1.603 2.028-2.103.836-.5 1.786-.754 2.851-.754.703 0 1.413.12 2.142.367h.006z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint0_linear_1_65",
                        x1: "16.195",
                        x2: "44.537",
                        y1: "23.805",
                        y2: "23.805",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#7677A2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#9293C9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_1_65",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0H369.865V40H0z"
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var logo = (DebtReliefCornerLogo);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/debtReliefCornerWrapper.tsx








const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function DebtReliefCornerWrapper({ children , boxShadow  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Debt Relief",
                    domain: "DebtReliefCorner.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Debt Relief ",
                    domain: "DebtReliefCorner.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Open Sans', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "Find the Right debt relief For You",
                        boxShadow: boxShadow,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ })

}]);